(function () {
  "use strict";

  // === Config ===
  const cartForm = document.getElementById("cart");
  const root = document.getElementById("nu-invoice");
  if (!root || !cartForm) return;

  // cart-items.js replaces .cart__summary's innerHTML (never the element itself), so this
  // reference stays valid for the lifetime of the page — safe to cache once, like cartForm.
  const cartSummaryEl = document.querySelector(".cart__summary");

  const config = {
    enableOpenData: root.dataset.enableOpendata === "true",
    allowCheckoutOnFail: root.dataset.allowCheckoutOnFail === "true",
    allowCheckoutOnStatusError: root.dataset.allowCheckoutOnStatusError === "true",
    showSuggestedCompany: root.dataset.showSuggestedCompany === "true",
    workerUrl: (root.dataset.workerUrl || "").trim(),
    nonprofitDataUrl: (root.dataset.nonprofitDataUrl || "").trim(),
    messages: {
      guiFormatError: root.dataset.msgGuiFormatError || "Please enter a valid tax id.",
      guiNotFound: root.dataset.msgGuiNotFound || "Tax id not found.",
      companyMismatch: root.dataset.msgCompanyMismatch || "Company title does not match.",
      checkoutBlocked: root.dataset.msgCheckoutBlocked || "Cannot checkout.",
      bypassConfirm: root.dataset.msgBypassConfirm || "I confirm and continue checkout.",
      companyStatusError: root.dataset.msgCompanyStatusError || "Company status abnormal.",
      bypassStatusConfirm:
        root.dataset.msgBypassStatusConfirm || "I acknowledge abnormal status and continue.",
      invoiceIncomplete:
        root.dataset.msgInvoiceIncomplete || "請確認完成發票資訊的填寫。",
      validationSuccess: root.dataset.msgValidationSuccess || "Validation successful.",
      validationError: root.dataset.msgValidationError || "Validation failed.",
      workerUrlRequired: "請先於 Theme Editor 填寫 Cloudflare Worker URL。",
    },
  };

  // === Elements ===
  // #nu-invoice (and everything inside it) is rendered inside .cart__summary, which
  // Shopify's native cart-items.js replaces via innerHTML on every quantity change on the
  // cart page (see getSectionsToRender()/updateQuantity() in assets/cart-items.js).
  // innerHTML-inserted <script> tags never execute, so this file only ever runs once per
  // full page load — any element reference cached at that point goes stale the moment such
  // a refresh happens. cartForm (<form id="cart">) is the only element in this flow that
  // lives OUTSIDE .cart__summary and is never replaced; every other element below is looked
  // up fresh via getEls() whenever it's needed, and every listener that used to bind
  // directly to one of these elements is delegated through cartForm instead.
  //
  // 警告：assets/bss-custom.js（第三方維護，非本專案客製檔）用 document.querySelector 直接讀取
  // #nu-invoice-tax-id、#nu-invoice-company-title 等 id。重新命名或調整這些欄位結構前，請先確認
  // bss-custom.js 是否同步更新，否則 BSS 訂單附加資訊會靜默失效且不會有任何錯誤訊息。
  function getEls() {
    return {
      checkoutHint: document.getElementById("nu-invoice-checkout-hint"),
      companyFields: document.getElementById("nu-invoice-company-fields"),
      taxIdInput: document.getElementById("nu-invoice-tax-id"),
      companyTitleInput: document.getElementById("nu-invoice-company-title"),
      taxIdStatus: document.getElementById("nu-invoice-tax-id-status"),
      companyTitleStatus: document.getElementById("nu-invoice-company-title-status"),
      taxIdLoading: document.getElementById("nu-invoice-tax-id-loading"),
      companyTitleLoading: document.getElementById("nu-invoice-company-title-loading"),
      taxIdError: document.getElementById("nu-invoice-tax-id-error"),
      taxIdErrorExtra: document.getElementById("nu-invoice-tax-id-error-extra"),
      companyTitleError: document.getElementById("nu-invoice-company-title-error"),
      companyTitleErrorExtra: document.getElementById("nu-invoice-company-title-error-extra"),
      suggestedCompany: document.getElementById("nu-invoice-suggested-company"),
      bypassRow: document.getElementById("nu-invoice-bypass-row"),
      bypassCheckbox: document.getElementById("nu-invoice-bypass"),
      bypassText: document.getElementById("nu-invoice-bypass-text"),
    };
  }

  // === State ===
  const abnormalStatuses = new Set([
    "解散",
    "撤銷",
    "废止",
    "廢止",
    "歇業",
    "清算",
    "註銷",
    "注销",
    "停業",
    "停止營業",
    "停止营业",
    "終止",
  ]);
  const state = {
    invoiceType: "personal",
    taxId: "",
    companyTitle: "",
    taxIdValid: false,
    openDataResult: "idle", // idle | loading | success | not_found | mismatch | status_error | worker_missing
    bypassChecked: false,
    suggestedName: "",
    failReason: "",
    companyData: null,
  };
  let debounceTimer = null;
  let companyDebounceTimer = null;
  let invoiceSyncTimer = null;
  let isSubmitting = false;
  let validationRequestId = 0;
  function isAbnormalCompanyStatus(statusDesc) {
    if (!statusDesc) return false;
    const value = String(statusDesc);
    for (const keyword of abnormalStatuses) {
      if (value.includes(keyword)) return true;
    }
    return false;
  }


  // === Validators ===
  function validateGuiNumber(value) {
    const digits = (value || "").replace(/\D/g, "");
    if (!/^\d{8}$/.test(digits)) return false;
    const weights = [1, 2, 1, 2, 1, 2, 4, 1];
    let sum = 0;

    for (let i = 0; i < 8; i += 1) {
      const product = Number(digits[i]) * weights[i];
      sum += Math.floor(product / 10) + (product % 10);
    }

    if (sum % 10 === 0) return true;
    if (digits[6] === "7" && (sum + 1) % 10 === 0) return true;
    return false;
  }

  function nowTwString() {
    const date = new Date();
    const tw = new Date(date.getTime() + 8 * 60 * 60 * 1000);
    const iso = tw.toISOString().slice(0, 19);
    return iso.replace("T", " ");
  }

  function setStatusBadge(el, status) {
    if (!el) return;
    el.classList.remove("is-success", "is-error");
    el.textContent = "";
    if (status === "success") {
      el.classList.add("is-success");
      el.textContent = "✓";
      el.setAttribute("aria-hidden", "false");
      el.setAttribute("aria-label", config.messages.validationSuccess);
    } else if (status === "error") {
      el.classList.add("is-error");
      el.textContent = "!";
      el.setAttribute("aria-hidden", "false");
      el.setAttribute("aria-label", config.messages.validationError);
    } else {
      el.setAttribute("aria-hidden", "true");
      el.removeAttribute("aria-label");
    }
  }

  // Derives an error container's associated input from its id convention
  // (#nu-invoice-tax-id-error / #nu-invoice-tax-id-error-extra -> #nu-invoice-tax-id) so
  // aria-invalid can be kept in sync without threading the input element through every one
  // of showError()'s many call sites.
  function syncAriaInvalidForErrorEl(el) {
    if (!el || !el.id) return;
    const inputId = el.id.replace(/-error(-extra)?$/, "");
    if (inputId === el.id) return;
    const inputEl = document.getElementById(inputId);
    if (!inputEl) return;
    const primaryHidden = document.getElementById(`${inputId}-error`)?.hidden !== false;
    const extraHidden = document.getElementById(`${inputId}-error-extra`)?.hidden !== false;
    inputEl.setAttribute("aria-invalid", primaryHidden && extraHidden ? "false" : "true");
  }

  function showError(el, message) {
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = "";
      el.hidden = true;
    }
    syncAriaInvalidForErrorEl(el);
  }

  function showErrorPair(primaryEl, secondaryEl, primaryMessage, secondaryMessage) {
    showError(primaryEl, primaryMessage || "");
    showError(secondaryEl, secondaryMessage || "");
  }

  function toggleLoading(el, on) {
    if (!el) return;
    el.hidden = !on;
  }

  function getCheckoutButtons() {
    return Array.from(cartForm.querySelectorAll('button[name="checkout"]'));
  }

  function getPrimaryCheckoutButton() {
    const buttons = getCheckoutButtons();
    return buttons.length ? buttons[0] : null;
  }

  // Other independent scripts on this cart page (e.g. nu--cart-order-information.liquid)
  // may also need to hide/disable these same elements for their own reasons. Track each
  // script's requirement as a named entry in a set stored directly on the element so
  // nobody clobbers another script's "still blocked" state — final state is "blocked if
  // any reason is still active".
  function setBlockReason(el, store, reasonKey, active) {
    if (!el) return false;
    const reasons = el[store] || (el[store] = new Set());
    if (active) reasons.add(reasonKey);
    else reasons.delete(reasonKey);
    return reasons.size > 0;
  }

  function setCheckoutEnabled(enabled) {
    getCheckoutButtons().forEach((button) => {
      const shouldDisable = setBlockReason(button, "__nuDisableReasons", "invoice", !enabled);
      button.disabled = shouldDisable;
      button.setAttribute("aria-disabled", String(shouldDisable));
    });
  }

  function setCheckoutHintVisible(visible) {
    const { checkoutHint } = getEls();
    if (!checkoutHint) return;
    checkoutHint.hidden = !visible;
    if (visible && !checkoutHint.textContent.trim()) {
      checkoutHint.textContent = config.messages.invoiceIncomplete;
    }
  }

  function openContainingDisclosure(el) {
    if (!el) return;
    const disclosureDetails = el.closest("details");
    if (disclosureDetails && !disclosureDetails.open) {
      disclosureDetails.open = true;
    }
  }

  function resetOpenDataState() {
    const { bypassCheckbox, suggestedCompany, bypassRow, bypassText, taxIdError, taxIdErrorExtra, companyTitleError, companyTitleErrorExtra, companyTitleStatus } = getEls();
    state.openDataResult = "idle";
    state.failReason = "";
    state.bypassChecked = false;
    state.suggestedName = "";
    state.companyData = null;
    if (bypassCheckbox) bypassCheckbox.checked = false;
    if (suggestedCompany) {
      suggestedCompany.hidden = true;
      suggestedCompany.textContent = "";
    }
    if (bypassRow) bypassRow.hidden = true;
    if (bypassText) bypassText.textContent = "";
    showErrorPair(taxIdError, taxIdErrorExtra, "", "");
    showErrorPair(companyTitleError, companyTitleErrorExtra, "", "");
    setStatusBadge(companyTitleStatus, "");
  }

  function syncUiForInvoiceType() {
    const { companyFields, taxIdError, taxIdErrorExtra, companyTitleError, companyTitleErrorExtra, taxIdStatus, companyTitleStatus } = getEls();
    const isCompany = state.invoiceType === "company";
    if (companyFields) companyFields.hidden = !isCompany;

    if (!isCompany) {
      showErrorPair(taxIdError, taxIdErrorExtra, "", "");
      showErrorPair(companyTitleError, companyTitleErrorExtra, "", "");
      setStatusBadge(taxIdStatus, "");
      setStatusBadge(companyTitleStatus, "");
      resetOpenDataState();
    }

    evaluateCheckoutState();
  }

  function getCanCheckoutState() {
    if (state.invoiceType !== "company") return true;

    let canCheckout = false;
    if (!state.taxIdValid) {
      canCheckout = false;
    } else if (!state.companyTitle.trim()) {
      canCheckout = false;
    } else if (!config.enableOpenData) {
      canCheckout = true;
    } else if (state.openDataResult === "success") {
      canCheckout = true;
    } else if (state.openDataResult === "mismatch" && config.allowCheckoutOnFail) {
      canCheckout = state.bypassChecked;
    } else if (state.openDataResult === "status_error" && config.allowCheckoutOnStatusError) {
      canCheckout = state.bypassChecked;
    }
    // "not_found"（查無統編）故意不提供 bypass 分支——客戶已確認為刻意設計（2026-09-03），
    // 即使 allowCheckoutOnFail 開啟也不允許繞過，勿新增分支。

    return canCheckout;
  }

  // H-12: .cart__summary being replaced resets the invoice-type radio and bypass checkbox
  // (and re-renders company-title/tax-id from cart.attributes) without state.* knowing
  // anything happened — so state can go stale relative to what's actually on screen.
  // Re-derive the fields that getCanCheckoutState() actually gates on directly from the DOM
  // every time, right before that gate is evaluated, so the check always reflects what the
  // customer currently sees instead of whatever state happened to hold from before the last
  // replacement. This deliberately does not touch state.openDataResult/companyData/
  // failReason/suggestedName — those came from an actual OpenData lookup (or have no DOM
  // element to read back from at all, since 驗證結果/失敗原因 are write-only cart attributes
  // never re-rendered into the form) and re-deriving them here would either be impossible or
  // mean re-fetching on every cart refresh for no reason.
  function syncStateFromDom() {
    const { bypassCheckbox, companyTitleInput, taxIdInput } = getEls();
    const checkedTypeRadio = document.querySelector('#nu-invoice input[name="nu_invoice_type"]:checked');
    if (checkedTypeRadio) state.invoiceType = checkedTypeRadio.value;
    if (bypassCheckbox) state.bypassChecked = bypassCheckbox.checked;
    if (companyTitleInput) state.companyTitle = companyTitleInput.value || "";
    if (taxIdInput) {
      const digits = (taxIdInput.value || "").replace(/\D/g, "");
      state.taxId = digits;
      state.taxIdValid = digits.length === 8 ? validateGuiNumber(digits) : false;
    }
  }

  function evaluateCheckoutState() {
    syncStateFromDom();
    const canCheckout = getCanCheckoutState();
    setCheckoutEnabled(canCheckout);
    setCheckoutHintVisible(!canCheckout);
    scheduleInvoiceAttributeSync();
  }

  // === API ===
  async function fetchCompanyData(taxId) {
    if (!config.workerUrl) {
      console.error("[nu--invoice] Missing worker URL setting.");
      return null;
    }

    try {
      const url = new URL(config.workerUrl);
      url.searchParams.set("taxId", taxId);
      if (config.nonprofitDataUrl) {
        url.searchParams.set("nonprofitDataUrl", config.nonprofitDataUrl);
      }
      const response = await fetch(url.toString(), {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) return null;
      const data = await response.json();
      if (Array.isArray(data)) {
        if (!data.length) return null;
        return data[0];
      }

      if (!data || typeof data !== "object") return null;
      if (data.success === false) return null;
      if (data.success === true) {
        return {
          Business_Accounting_NO: data.taxId || taxId,
          Company_Name: data.companyName || "",
          Company_Status: data.companyStatus || "",
          Company_Status_Desc: data.companyStatusDesc || "",
        };
      }

      return null;
    } catch (error) {
      console.error("[nu--invoice] OpenData fetch error:", error);
      return null;
    }
  }

  function applySuggestedCompanyVisibility(companyName) {
    const { suggestedCompany } = getEls();
    if (!suggestedCompany) return;
    const currentTitle = (state.companyTitle || "").trim();
    const shouldShow =
      config.showSuggestedCompany &&
      companyName &&
      currentTitle !== companyName;
    if (shouldShow) {
      suggestedCompany.hidden = false;
      suggestedCompany.textContent = "建議公司名稱：" + companyName + " (點擊套用)";
      state.suggestedName = companyName;
    } else {
      suggestedCompany.hidden = true;
      suggestedCompany.textContent = "";
      state.suggestedName = companyName || "";
    }
  }

  function validateCompanyTitleWithCompanyData() {
    const { companyTitleError, companyTitleErrorExtra, taxIdError, taxIdErrorExtra, companyTitleStatus, taxIdStatus, bypassRow, bypassText } = getEls();
    const companyData = state.companyData;
    if (!companyData) {
      evaluateCheckoutState();
      return;
    }

    const companyName = (companyData.Company_Name || "").trim();
    const companyStatus = (companyData.Company_Status_Desc || "").trim();
    const inputTitle = state.companyTitle.trim();

    if (!inputTitle) {
      state.openDataResult = "idle";
      showErrorPair(companyTitleError, companyTitleErrorExtra, "", "");
      setStatusBadge(companyTitleStatus, "");
      applySuggestedCompanyVisibility(companyName);
      evaluateCheckoutState();
      return;
    }

    if (inputTitle !== companyName) {
      state.openDataResult = "mismatch";
      state.failReason = "統編與公司抬頭不匹配";
      setStatusBadge(companyTitleStatus, "error");
      setStatusBadge(taxIdStatus, "success");
      showErrorPair(taxIdError, taxIdErrorExtra, "", "");
      if (config.allowCheckoutOnFail) {
        showErrorPair(companyTitleError, companyTitleErrorExtra, config.messages.companyMismatch, "");
        if (bypassRow) bypassRow.hidden = false;
        if (bypassText) bypassText.textContent = config.messages.bypassConfirm;
      } else {
        showErrorPair(
          companyTitleError,
          companyTitleErrorExtra,
          config.messages.companyMismatch,
          config.messages.checkoutBlocked
        );
      }
      applySuggestedCompanyVisibility(companyName);
      evaluateCheckoutState();
      return;
    }

    if (isAbnormalCompanyStatus(companyStatus)) {
      state.openDataResult = "status_error";
      state.failReason = "單位狀態異常";
      showErrorPair(companyTitleError, companyTitleErrorExtra, config.messages.companyStatusError, "");
      showErrorPair(taxIdError, taxIdErrorExtra, "", "");
      setStatusBadge(companyTitleStatus, "error");
      setStatusBadge(taxIdStatus, "success");
      if (config.allowCheckoutOnStatusError) {
        if (bypassRow) bypassRow.hidden = false;
        if (bypassText) bypassText.textContent = config.messages.bypassStatusConfirm;
      } else if (bypassRow) {
        bypassRow.hidden = true;
      }
      applySuggestedCompanyVisibility("");
      evaluateCheckoutState();
      return;
    }

    state.openDataResult = "success";
    state.failReason = "";
    showErrorPair(taxIdError, taxIdErrorExtra, "", "");
    showErrorPair(companyTitleError, companyTitleErrorExtra, "", "");
    setStatusBadge(taxIdStatus, "success");
    setStatusBadge(companyTitleStatus, "success");
    if (bypassRow) bypassRow.hidden = true;
    if (bypassText) bypassText.textContent = "";
    applySuggestedCompanyVisibility("");
    evaluateCheckoutState();
  }

  async function saveToCart(attributes) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes }),
      });
    } catch (error) {
      console.error("[nu--invoice] Save cart attributes error:", error);
    }
  }

  async function saveCurrentInvoiceAttributes() {
    if (state.invoiceType === "personal") {
      await saveToCart({
        發票類型: "personal",
        統一編號: "",
        公司抬頭: "",
        驗證結果: "",
        失敗原因: "",
        驗證時間: "",
        備註: "",
      });
      return;
    }

    if (state.openDataResult === "success") {
      await saveToCart({
        發票類型: "company",
        統一編號: state.taxId,
        公司抬頭: state.companyTitle.trim(),
        驗證結果: "success",
        失敗原因: "",
        驗證時間: nowTwString(),
        備註: "",
      });
      return;
    }

    if (
      (state.openDataResult === "mismatch" && config.allowCheckoutOnFail && state.bypassChecked) ||
      (state.openDataResult === "status_error" &&
        config.allowCheckoutOnStatusError &&
        state.bypassChecked)
    ) {
      await saveToCart({
        發票類型: "company",
        統一編號: state.taxId,
        公司抬頭: state.companyTitle.trim(),
        驗證結果: "fail",
        失敗原因: state.failReason,
        驗證時間: nowTwString(),
        備註:
          state.openDataResult === "mismatch"
            ? config.messages.bypassConfirm
            : config.messages.bypassStatusConfirm,
      });
      return;
    }

    await saveToCart({
      發票類型: "company",
      統一編號: state.taxId || "",
      公司抬頭: state.companyTitle.trim(),
      驗證結果: "",
      失敗原因: state.failReason || "",
      驗證時間: "",
      備註: "",
    });
  }

  function scheduleInvoiceAttributeSync() {
    clearTimeout(invoiceSyncTimer);
    invoiceSyncTimer = setTimeout(() => {
      saveCurrentInvoiceAttributes();
    }, 300);
  }

  // === StateMachine ===
  async function validateOpenDataFromTaxIdChange() {
    const before = getEls();
    if (!config.enableOpenData || !state.taxIdValid) {
      evaluateCheckoutState();
      return;
    }

    showErrorPair(before.taxIdError, before.taxIdErrorExtra, "", "");
    showErrorPair(before.companyTitleError, before.companyTitleErrorExtra, "", "");
    if (before.bypassRow) before.bypassRow.hidden = true;
    if (before.bypassText) before.bypassText.textContent = "";

    if (!config.workerUrl) {
      state.openDataResult = "worker_missing";
      state.failReason = "";
      showErrorPair(before.taxIdError, before.taxIdErrorExtra, config.messages.workerUrlRequired, "");
      setStatusBadge(before.taxIdStatus, "error");
      showErrorPair(before.companyTitleError, before.companyTitleErrorExtra, "", "");
      setStatusBadge(before.companyTitleStatus, "");
      evaluateCheckoutState();
      return;
    }

    state.openDataResult = "loading";
    toggleLoading(before.companyTitleLoading, true);
    // Lock both the tax-id AND company-title fields for the duration of the lookup — not
    // just tax-id. Editing company title while this fetch is in flight used to bump
    // validationRequestId and make this call's own unlock step get skipped as "stale",
    // leaving the tax-id field permanently read-only. Locking company title too means
    // neither field can fire the input event that bumps validationRequestId during the
    // lookup, so that race can no longer happen.
    if (before.taxIdInput) before.taxIdInput.readOnly = true;
    if (before.companyTitleInput) before.companyTitleInput.readOnly = true;
    setCheckoutEnabled(false);

    const currentRequestId = ++validationRequestId;
    const companyData = await fetchCompanyData(state.taxId);

    // Re-query after the await — if a .cart__summary refresh happened while this fetch was
    // in flight (e.g. the customer changed a cart line's quantity), every element above is
    // now a detached node; unlocking those wouldn't do anything for what the customer is
    // actually looking at. Unlock unconditionally, independent of the staleness check below
    // (which now only guards the result-handling that follows, not the lock itself).
    const after = getEls();
    if (after.taxIdInput) after.taxIdInput.readOnly = false;
    if (after.companyTitleInput) after.companyTitleInput.readOnly = false;
    toggleLoading(after.companyTitleLoading, false);

    if (currentRequestId !== validationRequestId) {
      return;
    }

    if (!companyData) {
      state.openDataResult = "not_found";
      state.failReason = "";
      state.companyData = null;
      showErrorPair(after.taxIdError, after.taxIdErrorExtra, config.messages.guiNotFound, "");
      setStatusBadge(after.taxIdStatus, "error");
      // Tax id not found is not the same failure as "company status abnormal" — leave
      // companyTitleError/Status empty rather than borrowing that unrelated message.
      showErrorPair(after.companyTitleError, after.companyTitleErrorExtra, "", "");
      setStatusBadge(after.companyTitleStatus, "");
      if (after.suggestedCompany) after.suggestedCompany.hidden = true;
      evaluateCheckoutState();
      return;
    }

    state.companyData = companyData;
    state.openDataResult = "idle";
    state.failReason = "";
    showErrorPair(after.taxIdError, after.taxIdErrorExtra, "", "");
    setStatusBadge(after.taxIdStatus, "success");
    validateCompanyTitleWithCompanyData();
  }

  function runTaxIdValidation(forceStrictOnChange) {
    const { taxIdInput, taxIdLoading, taxIdStatus, taxIdError, taxIdErrorExtra } = getEls();
    if (!taxIdInput) return;
    state.taxId = (taxIdInput.value || "").replace(/\D/g, "");
    taxIdInput.value = state.taxId;

    toggleLoading(taxIdLoading, true);
    const taxIdLength = state.taxId.length;
    if (taxIdLength === 0) {
      state.taxIdValid = false;
      toggleLoading(taxIdLoading, false);
      resetOpenDataState();
      if (forceStrictOnChange) {
        setStatusBadge(taxIdStatus, "error");
        showErrorPair(taxIdError, taxIdErrorExtra, config.messages.guiFormatError, "");
      } else {
        setStatusBadge(taxIdStatus, "");
        showErrorPair(taxIdError, taxIdErrorExtra, "", "");
      }
      evaluateCheckoutState();
      return;
    }

    if (taxIdLength < 8) {
      state.taxIdValid = false;
      toggleLoading(taxIdLoading, false);
      resetOpenDataState();
      if (forceStrictOnChange) {
        setStatusBadge(taxIdStatus, "error");
        showErrorPair(taxIdError, taxIdErrorExtra, config.messages.guiFormatError, "");
      } else {
        setStatusBadge(taxIdStatus, "");
        showErrorPair(taxIdError, taxIdErrorExtra, "", "");
      }
      evaluateCheckoutState();
      return;
    }

    state.taxIdValid = validateGuiNumber(state.taxId);
    toggleLoading(taxIdLoading, false);
    resetOpenDataState();

    if (!state.taxIdValid) {
      setStatusBadge(taxIdStatus, "error");
      showErrorPair(taxIdError, taxIdErrorExtra, config.messages.guiFormatError, "");
      evaluateCheckoutState();
      return;
    }

    setStatusBadge(taxIdStatus, "success");
    showErrorPair(taxIdError, taxIdErrorExtra, "", "");
    state.companyData = null;
  }

  function scheduleTaxIdValidation() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => runTaxIdValidation(false), 300);
  }

  // === Init ===
  // All listeners below are delegated onto cartForm (stable, outside .cart__summary)
  // instead of binding directly to the fields themselves (which live inside .cart__summary
  // and are replaced on every cart quantity change) — see the getEls() comment above.

  cartForm.addEventListener("change", (event) => {
    const target = event.target;

    if (target.matches && target.matches('#nu-invoice input[name="nu_invoice_type"]')) {
      state.invoiceType = target.value;
      if (state.invoiceType === "personal") {
        // Invalidate any in-flight validateOpenDataFromTaxIdChange() call so its result
        // can't land after the customer has already switched away from "company".
        validationRequestId += 1;
        const { taxIdInput, companyTitleInput, companyTitleLoading } = getEls();
        state.taxId = "";
        state.companyTitle = "";
        state.taxIdValid = false;
        state.openDataResult = "idle";
        state.failReason = "";
        if (taxIdInput) {
          taxIdInput.value = "";
          // Don't wait for an in-flight validateOpenDataFromTaxIdChange() lookup to unlock
          // these on its own — that only happens once the (now-irrelevant) fetch resolves,
          // leaving the fields stuck read-only for however long the request takes if the
          // customer switches straight back to "company" in the meantime.
          taxIdInput.readOnly = false;
        }
        if (companyTitleInput) {
          companyTitleInput.value = "";
          companyTitleInput.readOnly = false;
        }
        toggleLoading(companyTitleLoading, false);
      }
      syncUiForInvoiceType();

      // Do not block UI collapse when switching to personal invoice.
      if (state.invoiceType === "personal") {
        saveCurrentInvoiceAttributes();
      }
      return;
    }

    if (target.id === "nu-invoice-tax-id") {
      // Clear the debounce armed by the "input" handler below — if the user types then
      // blurs within the debounce window, the strict "change" validation here should be
      // the one that runs, not a stale delayed non-strict re-run on top of it.
      clearTimeout(debounceTimer);
      runTaxIdValidation(true);
      if (state.taxIdValid && config.enableOpenData) {
        validateOpenDataFromTaxIdChange();
      } else {
        // runTaxIdValidation()'s own "valid" path doesn't call evaluateCheckoutState()
        // (callers are expected to do that themselves once OpenData validation, if any,
        // settles) — see the identical comment in initFromExistingValues(). With OpenData
        // disabled nothing else will, so without this the Checkout button could stay stuck
        // disabled after a live tax-id edit even though it's now valid (H-39).
        evaluateCheckoutState();
      }
      return;
    }

    if (target.id === "nu-invoice-bypass") {
      state.bypassChecked = target.checked;
      evaluateCheckoutState();
    }
  });

  cartForm.addEventListener("input", (event) => {
    const target = event.target;

    if (target.id === "nu-invoice-tax-id") {
      validationRequestId += 1;
      resetOpenDataState();
      scheduleTaxIdValidation();
      return;
    }

    if (target.id === "nu-invoice-company-title") {
      const { bypassCheckbox, bypassRow, bypassText, companyTitleError, companyTitleErrorExtra, companyTitleStatus } = getEls();
      state.companyTitle = target.value || "";
      validationRequestId += 1;
      // Bumping validationRequestId above invalidates any in-flight
      // validateOpenDataFromTaxIdChange() call — but that call now unlocks its fields
      // unconditionally (see the "after" re-query there), so no extra unlock is needed here.
      state.openDataResult = "idle";
      state.failReason = "";
      state.bypassChecked = false;
      if (bypassCheckbox) bypassCheckbox.checked = false;
      if (bypassRow) bypassRow.hidden = true;
      if (bypassText) bypassText.textContent = "";
      showErrorPair(companyTitleError, companyTitleErrorExtra, "", "");
      setStatusBadge(companyTitleStatus, "");
      clearTimeout(companyDebounceTimer);
      if (state.taxIdValid) {
        companyDebounceTimer = setTimeout(() => {
          if (!config.enableOpenData) {
            evaluateCheckoutState();
            return;
          }
          if (state.companyData) {
            validateCompanyTitleWithCompanyData();
          } else {
            validateOpenDataFromTaxIdChange();
          }
        }, 500);
      }
      evaluateCheckoutState();
    }
  });

  cartForm.addEventListener("click", (event) => {
    if (event.target.closest && event.target.closest("#nu-invoice-suggested-company")) {
      const { companyTitleInput, suggestedCompany } = getEls();
      if (!state.suggestedName || !companyTitleInput) return;
      companyTitleInput.value = state.suggestedName;
      state.companyTitle = state.suggestedName;
      if (suggestedCompany) suggestedCompany.hidden = true;
      clearTimeout(companyDebounceTimer);
      validateCompanyTitleWithCompanyData();
    }
  });

  async function resubmitAfterSavingAttributes() {
    setCheckoutEnabled(false);
    isSubmitting = true;
    await saveCurrentInvoiceAttributes();
    cartForm.requestSubmit(getPrimaryCheckoutButton() || undefined);
    // requestSubmit() dispatches (and fully handles) its own synchronous "submit" event before
    // returning, so by this point we already know whether the resubmit actually navigated away
    // or was blocked by another submit listener (e.g. nu--cart-order-information.liquid's
    // required-field check). setCheckoutEnabled(false) above must not outlive a blocked resubmit —
    // otherwise the "invoice" checkout-block reason stays stuck forever, since nothing else ever
    // clears it, and the Checkout button never re-enables even after the real blocker is fixed.
    // If the page did navigate away, this call is moot (the page is already unloading).
    evaluateCheckoutState();
  }

  cartForm.addEventListener("submit", async (event) => {
    if (event.defaultPrevented) return;
    if (isSubmitting) {
      isSubmitting = false;
      return;
    }

    if (state.invoiceType !== "company") {
      event.preventDefault();
      event.stopPropagation();
      await resubmitAfterSavingAttributes();
      return;
    }

    evaluateCheckoutState();
    const canCheckout = getCanCheckoutState();
    setCheckoutEnabled(canCheckout);
    setCheckoutHintVisible(!canCheckout);
    if (!canCheckout) {
      event.preventDefault();
      event.stopPropagation();
      const { taxIdInput, companyTitleInput, taxIdError } = getEls();
      const taxIdHasVisibleError = Boolean(taxIdError && !taxIdError.hidden);
      if (!state.taxIdValid) {
        // The customer may never have touched this field (so no error text has ever been
        // shown yet) — force a strict validation pass so the field-level error actually
        // appears instead of just silently moving focus there with no visible reason.
        runTaxIdValidation(true);
        openContainingDisclosure(taxIdInput);
        if (taxIdInput) taxIdInput.focus();
      } else if (taxIdHasVisibleError) {
        // Format is valid, but the tax-id field currently has an OpenData-driven error shown
        // on it (not_found / worker_missing) — just move focus/scroll there, don't run
        // runTaxIdValidation(true): since the format itself is fine, that would overwrite this
        // error with a "success" state and hide the very message we're focusing the user to.
        openContainingDisclosure(taxIdInput);
        if (taxIdInput) taxIdInput.focus();
      } else {
        openContainingDisclosure(companyTitleInput);
        if (companyTitleInput) companyTitleInput.focus();
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    await resubmitAfterSavingAttributes();
  });

  // H-10/H-12/M-11: re-apply checkout gating (the primary "Checkout" button's
  // enabled/disabled state and hint text — Dynamic Checkout is suppressed at render time
  // whenever invoice is enabled, see sections/main-cart.liquid, so there's nothing left to
  // toggle for it here) whenever .cart__summary gets replaced — no single DOM event fires
  // reliably across every path that can trigger that replacement (quantity change, a
  // cart-page add-on widget's delayed refresh, or any future source), but a childList
  // mutation on .cart__summary itself always fires once the replacement has actually
  // happened, regardless of what caused it. evaluateCheckoutState() re-derives
  // state.bypassChecked/companyTitle/taxIdValid from the fresh DOM first (see
  // syncStateFromDom() above) before re-checking whether checkout should stay gated.
  if (cartSummaryEl && typeof MutationObserver !== "undefined") {
    const cartSummaryObserver = new MutationObserver(() => {
      evaluateCheckoutState();
    });
    cartSummaryObserver.observe(cartSummaryEl, { childList: true, subtree: true });
  }

  // Establish initial state from whatever is actually on screen — nu--invoice-ui.liquid
  // now pre-fills the invoice type radio/tax-id/company-title from cart.attributes (see
  // H-8), but this script runs only once per full page load and would otherwise default
  // state.invoiceType to "personal" regardless. Without this, a returning customer (or a
  // customer who triggered a .cart__summary refresh by changing a cart quantity — the
  // same trigger as H-7) would see their company invoice fields correctly pre-filled by
  // Liquid, yet checkout would stay gated as if nothing had been entered, because
  // state.taxIdValid/openDataResult never got re-derived to match.
  (function initFromExistingValues() {
    const { taxIdInput, companyTitleInput } = getEls();
    const checkedRadio = document.querySelector('#nu-invoice input[name="nu_invoice_type"]:checked');
    state.invoiceType = checkedRadio ? checkedRadio.value : "personal";
    state.companyTitle = companyTitleInput ? (companyTitleInput.value || "") : "";

    syncUiForInvoiceType();

    if (state.invoiceType === "company" && taxIdInput && taxIdInput.value) {
      runTaxIdValidation(true);
      if (state.taxIdValid && config.enableOpenData) {
        validateOpenDataFromTaxIdChange();
      } else {
        // runTaxIdValidation()'s own "valid" path doesn't call evaluateCheckoutState()
        // (callers are expected to do that themselves once OpenData validation, if any,
        // settles) — with OpenData disabled nothing else will, so do it here to make sure
        // the checkout button/hint reflect the restored taxIdValid state right away.
        evaluateCheckoutState();
      }
    }
  })();
})();
